import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useMembers } from "../../../hooks/useMembers";

import "./HomeSocis.css";

// Registramos el plugin ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

function HomeSocis() {
  const { numSocis } = useMembers();

  // Referencia para el número
  const numberRef = useRef(null);
  // Referencias para los elementos de la galería
  const galleryRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  // Configuramos diferentes velocidades y distancias para cada imagen
  const animations = [
    { speed: 0.3, distance: 150 },
    { speed: 0.5, distance: 300 },
    { speed: 0.2, distance: 180 },
    { speed: 0.4, distance: 230 },
    { speed: 0.6, distance: 110 },
  ];

  useGSAP(() => {
    // Només configura l'animació si tenim un valor vàlid de numSocis
    if (numSocis > 0 && numberRef.current) {
      // Guardem el valor actual per mostrar-lo correctament
      const valorActual = numSocis;

      // Configurem l'animació amb el valor final correcte
      gsap.fromTo(
        numberRef.current,
        { innerHTML: 0 }, // Comencem des de 0
        {
          innerHTML: valorActual, // Animem fins al valor actual
          duration: 2,
          ease: "power1.out",
          snap: { innerHTML: 1 },
          scrollTrigger: {
            trigger: numberRef.current,
            start: "top center+=150",
            once: true,
          },
          onUpdate: function () {
            numberRef.current.innerHTML = Math.ceil(
              this.targets()[0].innerHTML
            );
          },
        }
      );
    }

    galleryRefs.forEach((ref, index) => {
      gsap.to(ref.current, {
        y: animations[index].distance,
        ease: "none",
        scrollTrigger: {
          trigger: ref.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          speed: animations[index].speed,
        },
      });
    });
  }, [numSocis]);

  return (
    <section className="home-socis">
      <div className="home-socis__content">
        <div className="home-socis__main-content">
          <div className="big-number" ref={numberRef}>
            {numSocis}
          </div>
          <div className="label">SOCIS</div>
          <div className="home-socis__participa-link">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeg7f_ucxeBr9YbUrrAQc7H4bbBhs7en6BCPT4GKwb2mzGjwg/viewform"
              target="_blank"
              rel="noreferrer"
            >
              PARTICIPA
            </a>
          </div>
        </div>

        <div className="home-socis__gallery">
          {[1, 2, 3, 4, 5].map((num, index) => (
            <div
              key={num}
              ref={galleryRefs[index]}
              className={`gallery-item gallery-item--${num}`}
            ></div>
          ))}
        </div>

        <div className="home-socis__text">
          <p>
            El Casal Popular La Flama és un projecte autogestionat i col·lectiu
            que construïm entre totes i tots. Fes-te soci/a i ajuda'ns a
            construir una Cerdanyola més empoderada i justa socialment.
          </p>
        </div>
      </div>
    </section>
  );
}

export default HomeSocis;
